if (!customElements.get('lp-sticky-button')) {
  customElements.define(
    'lp-sticky-button',

    class LpStickyButton extends HTMLElement {
      connectedCallback() {
        this.bar      = this.querySelector('[data-bar]');
        this.cta      = this.querySelector('[data-cta]');
        this.dropdown = this.querySelector('[data-dropdown]');
        this.backdrop = this.querySelector('[data-backdrop]');
        this.btnText  = this.querySelector('[data-btn-text]');
        this.atcText     = this.dataset.atcText || 'In den Warenkorb';
        this.initialText = this.btnText.textContent;

        // Close dropdown when clicking anywhere outside [data-bar]
        this._closeOnOutsideClick = () => this.close();
        this.bar.addEventListener('click', e => e.stopPropagation());
        this.setupVisibility();
        this.setupCta();
        this.setupItems();
      }

      /* --------------------------------------------------------
         Visibility: show bar when the trigger section's bottom
         edge has crossed the top 20 % of the viewport
      -------------------------------------------------------- */
      setupVisibility() {
        const target = document.getElementById(this.dataset.trigger);
        console.log(target);
        if (!target) return;

        const update = () => {
          const { bottom } = target.getBoundingClientRect();
          if (bottom < window.innerHeight * 0.20) {
            this.bar.classList.add('is-visible');
          } else {
            this.bar.classList.remove('is-visible');
            this.close();
          }
        };

        window.addEventListener('scroll', update, { passive: true });
        update();
      }

      /* --------------------------------------------------------
         CTA button: toggle dropdown (idle) or add to cart (ready)
      -------------------------------------------------------- */
      setupCta() {
        this.cta.addEventListener('click', () => {
          if (this.cta.dataset.state === 'ready') {
            this.addToCart(this.cta.dataset.variantId);
          } else {
            this.dropdown.classList.contains('is-open') ? this.close() : this.open();
          }
        });

        // backdrop is visual-only; outside-click is handled via document listener
      }

      /* --------------------------------------------------------
         Product rows: select a variant, switch button to ATC
      -------------------------------------------------------- */
      setupItems() {
        this.querySelectorAll('[data-item]').forEach(item => {
          item.addEventListener('click', () => {
            this.querySelectorAll('[data-item]').forEach(i => {
              i.classList.remove('is-selected');
              i.setAttribute('aria-selected', 'false');
            });

            item.classList.add('is-selected');
            item.setAttribute('aria-selected', 'true');

            this.cta.dataset.variantId = item.dataset.variantId;
            this.cta.dataset.state     = 'ready';
            this.btnText.textContent   = this.atcText;
            this.cta.classList.add('is-active');
            this.cta.classList.remove('dropdown-open');
          });
        });
      }

      /* --------------------------------------------------------
         Dropdown helpers
      -------------------------------------------------------- */
      open() {
        this.dropdown.classList.add('is-open');
        this.bar.classList.add('dropdown-open');
        this.backdrop?.classList.add('is-open');
        this.cta.setAttribute('aria-expanded', 'true');
        this.cta.classList.add('dropdown-open');
        document.addEventListener('click', this._closeOnOutsideClick);
      }

      close() {
        this.dropdown?.classList.remove('is-open');
        this.bar?.classList.remove('dropdown-open');
        this.backdrop?.classList.remove('is-open');
        this.cta?.setAttribute('aria-expanded', 'false');
        this.cta?.classList.remove('dropdown-open');
        document.removeEventListener('click', this._closeOnOutsideClick);
        this.reset();
      }

      reset() {
        this.querySelectorAll('[data-item]').forEach(i => {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
        });
        this.cta.dataset.variantId = '';
        this.cta.dataset.state     = 'idle';
        this.cta.classList.remove('is-active');
        this.btnText.textContent   = this.initialText;
      }

      /* --------------------------------------------------------
         Add-to-cart via the theme's hidden <product-form> so
         that sections-bundling and cart-drawer updates work
         exactly the same as a normal product page ATC.
      -------------------------------------------------------- */
      addToCart(variantId) {
        if (!variantId) return;

        const productForm = this.querySelector(`[data-sticky-form="${variantId}"]`);
        if (!productForm) return;

        const form = productForm.querySelector('form');
        if (!form) return;

        this.cta.disabled = true;
        this.cta.classList.add('is-loading');

        const reset = () => {
          this.cta.disabled = false;
          this.cta.classList.remove('is-loading');
        };

        productForm.addEventListener('variant:add', () => {
          this.btnText.textContent = '✓ Hinzugefügt';
          setTimeout(() => {
            reset();
            this.reset();
          }, 2200);
        }, { once: true });

        productForm.addEventListener('cart:error', () => {
          this.btnText.textContent = this.atcText;
          reset();
        }, { once: true });

        form.requestSubmit();
      }
    }
  );
}
